import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // The state that we want to track in this application
    unansweredCards: [], // Pool of questions to be shown to the user
    answeredCards: [], // Questions that have been correctly answered
    currentCard: {
      question: "Sample question",
      answer: "Sample answer",
    },
    flipped: false, // Whether to show the question or answer
    index: 0, //card index
  },
  getters: {
    currentQuestion(state) {
      return state.currentCard.question;
    },
    currentAnswer(state) {
      return state.currentCard.answer;
    },
    currentScore(state) {
      return state.currentCard.score === undefined
        ? 1
        : state.currentCard.score;
    },
    currentPercent(state) {
      if (state.unansweredCards.length <= 0) {
        return 100;
      }
      return (state.index / state.unansweredCards.length) * 100;
    },
  },
  mutations: {
    // The changes to the state that we'll be making
    setUnanswered(state, questions) {
      // To intitially load the questions from the JSON file you made earlier
      state.unansweredCards = questions;
      this.index = 0;
    },
    pushUnanswered(state, question) {
      // When a question was answered incorrectly
      state.unansweredCards.push(question);
    },
    pushAnswered(state, question) {
      // When a question was answered correctly
      state.unansweredCards = state.unansweredCards.filter(
        (q) => q !== question
      );
      state.answeredCards.push(question);
    },
    setCurrentCard(state, question) {
      // Setting the question to be rendered
      state.currentCard = question;
      state.flipped = false;
    },
    setNextCard(state) {
      state.flipped = false;
      if (state.index >= state.unansweredCards.length) {
        return;
      }
      state.currentCard = state.unansweredCards[state.index];
      state.index++;
    },
    flipCard(state) {
      state.flipped = !state.flipped;
    },
  },
  actions: {
    init(context) {
      context.commit("setNextCard");
    },
    correctAnswer(context) {
      // const question = context.state.currentCard;
      // context.commit("pushAnswered", question);
      context.commit("setNextCard");
      // context.commit("setCurrentCard", randomQuestion(context));
    },
    wrongAnswer(context) {
      const question = context.state.currentCard;
      context.commit("pushUnanswered", question);
      context.commit("setNextCard");
    },
    doubtAnswer(context) {
      context.commit("setNextCard");
    },
  },
});
